import React, { useEffect, useState, useRef } from 'react';
import baseURL from '../url';
import './Products.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProductosLoading from '../ProductosLoading/ProductosLoading';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import { useCategoria } from '../CategoriaContext';
import useIsMobile from '../Navbar/useIsMobile';
import CuponesModal from '../CuponesModal/CuponesModal';

export default function Products() {
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fixedCategories, setFixedCategories] = useState(false);
    const categoriasRefs = useRef([]);
    const categoriasInputRef = useRef(null);
    const swiperRef = useRef(null);
    const [productos, setProductos] = useState([]);
    const [openCuponesModal, setOpenCuponesModal] = useState(true);
    const [codigos, setCodigos] = useState([]);
    const [cuponAplicado, setCuponAplicado] = useState(localStorage.getItem('cupon') || '');

    const { categoriaSeleccionada, setCategoriaSeleccionada } = useCategoria();
    const isMobile = useIsMobile();

    const handleClickCategoria = (categoria) => {
        setCategoriaSeleccionada(categoria);
    };

    useEffect(() => {
        // cargarProductos();
        cargarCategorias();

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        cargarProductosPorCategoria();
    }, [categoriaSeleccionada]);


    // Cargar códigos de descuento
    useEffect(() => {
        cargarCodigos();
    }, []);

    const handleScroll = () => {
        if (categoriasInputRef.current) {
            if (window.scrollY > categoriasInputRef.current.offsetTop) {
                setFixedCategories(true);
            } else {
                setFixedCategories(false);
            }
        }
    };


    const cargarProductos = () => {
        fetch(`${baseURL}/api/productos/catalogo`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/api/categorias`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const cargarCodigos = () => {
        fetch(`${baseURL}/api/codigos`, { method: "GET" })
            .then((response) => response.json())
            .then((data) => {
                setCodigos(data.codigos || []);
            })
            .catch((error) => console.error("Error al cargar códigos:", error));
    };

    const cargarProductosPorCategoria = () => {
        fetch(`${baseURL}/api/productos/catalogo?idCategoria=${categoriaSeleccionada === 'Todo' ? null : categoriaSeleccionada}`)
            .then(response => response.json())
            .then(data => {
                setProductos(Array.isArray(data.productos) ? data.productos : []);
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => {
        if (item.imagen1) {
            return item.imagen1;
        } else if (item.imagen2) {
            return item.imagen2;
        } else if (item.imagen3) {
            return item.imagen3;
        } else if (item.imagen4) {
            return item.imagen4;
        }
        return null;
    };

    // const categoriasConProductos = categorias.filter(categoria =>
    //     productos?.some(producto => producto?.idCategoria === categoria?.idCategoria)
    // );
    const categoriasConProductos = categorias;
    


    return (
        <div className='ProductsContain'>
            {/* Modal de Cupones */}
            {
                (codigos && codigos.length > 0 && cuponAplicado === '') &&
                <CuponesModal openModal={openCuponesModal} setOpenModal={setOpenCuponesModal} cuponesProps={codigos} setCuponAplicado={setCuponAplicado} />
            }

            {/* <ToastContainer /> */}
            {categoriasConProductos && categoriasConProductos.length > 0 && (
                <div className={`categoriasInputs ${fixedCategories ? 'fixed' : ''}`} ref={categoriasInputRef}>
                    <input
                        type="button"
                        value="Todo"
                        onClick={() => handleClickCategoria('Todo')}
                        style={{
                            backgroundColor: categoriaSeleccionada === 'Todo' ? 'var(--color1)' : '',
                            color: categoriaSeleccionada === 'Todo' ? '#fff' : '',
                            borderBottom: categoriaSeleccionada === 'Todo' ? '2px solid var(--color1)' : 'none'
                        }}
                    />
                    {categoriasConProductos.map(({ categoria, idCategoria }) => (
                        <input
                            key={idCategoria}
                            type="button"
                            value={categoria}
                            onClick={() => handleClickCategoria(idCategoria)}
                            style={{
                                backgroundColor: categoriaSeleccionada === idCategoria ? 'var(--color1)' : '',
                                color: categoriaSeleccionada === idCategoria ? '#fff' : '',
                                borderBottom: categoriaSeleccionada === idCategoria ? '2px solid var(--color1)' : 'none'
                            }}
                        />
                    ))}
                </div>
            )}


            {loading ? (
                <ProductosLoading />
            ) : (
                isMobile ? (
                    <div className='ProductsMobile'>
                        {categoriaSeleccionada === 'Todo'
                            ? (categoriasConProductos && categoriasConProductos.map(({ categoria, idCategoria }) => (
                                <div key={idCategoria} className="categoriaMobileSection">
                                    <h3 className="categoriaMobileTitle">{categoria}</h3>
                                    <div className="productosScrollHorizontal">
                                        {Array.isArray(productos) && productos
                                            .filter(item => item.idCategoria === idCategoria)
                                            .map(item => (
                                                <Anchor key={item.idProducto} to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}>
                                                    <div className='cardProductMobileVertical'>
                                                        <img src={obtenerImagen(item)} alt="imagen" />
                                                        <div className='cardTextMobileVertical'>
                                                            <h4>{item.titulo.length > 20 ? item.titulo.substring(0, 20) + '...' : item.titulo}</h4>
                                                            <div className='deFLexPrice'>
                                                                <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                                                                    <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Anchor>
                                            ))}
                                    </div>
                                </div>
                            )))
                            : (
                                <div className="categoriaMobileSection">
                                    <h3 className="categoriaMobileTitle">
                                        {categorias && categorias.find(cat => cat.idCategoria === categoriaSeleccionada)?.categoria}
                                    </h3>
                                    <div className="productosScrollHorizontal">
                                        {Array.isArray(productos) && productos
                                            .filter(item => item.idCategoria === categoriaSeleccionada)
                                            .map(item => (
                                                <Anchor key={item.idProducto} to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}>
                                                    <div className='cardProductMobileVertical'>
                                                        <img src={obtenerImagen(item)} alt="imagen" />
                                                        <div className='cardTextMobileVertical'>
                                                            <h4>{item.titulo.length > 20 ? item.titulo.substring(0, 20) + '...' : item.titulo}</h4>
                                                            <div className='deFLexPrice'>
                                                                <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                                                                    <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Anchor>
                                            ))}
                                    </div>
                                </div>
                            )}
                    </div>
                ) : (
                    <div className='Products'>
                        {categoriaSeleccionada === 'Todo' && (
                            <>
                                {Array.isArray(productos) && productos.some(item => item.masVendido === "si") && (
                                    <div className='categoriSection'>
                                        <Swiper
                                            effect={'coverflow'}
                                            grabCursor={true}
                                            slidesPerView={'auto'}
                                            id='swiper_container_products'
                                            autoplay={{ delay: 3000 }}
                                        >
                                            {Array.isArray(productos) && productos.filter(item => item.masVendido === "si").map(item => (
                                                <SwiperSlide key={item.idProducto} id='SwiperSlide-scroll-products-masvendidos'>
                                                    <Anchor className='cardProdcutmasVendido' to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}>
                                                        <img src={obtenerImagen(item)} alt="imagen" />
                                                        <h6 className='masVendido'>Más Vendido</h6>
                                                        <div className='cardText'>
                                                            <h4>{item.titulo}</h4>
                                                            <span>{item.descripcion}</span>
                                                            <div className='deFLexPrice'>
                                                                <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                                                                    <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </Anchor>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </div>
                                )}

                                {categoriasConProductos && categoriasConProductos.map(({ categoria, idCategoria }) => (
                                    <div key={idCategoria} className='categoriSection' ref={ref => categoriasRefs.current[categorias.findIndex(cat => cat.idCategoria === idCategoria)] = ref}>
                                        <div className='deFlexTitlesection'>
                                            <h3>{categoria}</h3>
                                            <button onClick={() => handleClickCategoria(idCategoria)}>
                                                Ver más
                                            </button>
                                        </div>

                                        <Swiper
                                            effect={'coverflow'}
                                            grabCursor={true}
                                            slidesPerView={'auto'}
                                            id='swiper_container_products'
                                        >


                                            {Array.isArray(productos) && productos.filter(item => item.idCategoria === idCategoria).map(item => (
                                                <SwiperSlide id='SwiperSlide-scroll-products' key={item.idProducto}>
                                                    <Anchor className='cardProdcut' key={item.idProducto} to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}>

                                                        <img src={obtenerImagen(item)} alt="imagen" />
                                                        <div className='cardText'>
                                                            <h4>{item.titulo}</h4>
                                                            <span>{item.descripcion}</span>
                                                            <div className='deFLexPrice'>
                                                                <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                                                                    <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                )}
                                                            </div>
                                                            <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard' />
                                                        </div>

                                                    </Anchor>
                                                </SwiperSlide>
                                            ))}

                                        </Swiper>
                                    </div>

                                ))}
                            </>
                        )}

                        <div className='categoriSectionSelected'>
                            {Array.isArray(productos) && productos
                                .filter(item => categoriaSeleccionada !== 'Todo' && item.idCategoria === categoriaSeleccionada)
                                .map(item => (
                                    <Anchor key={item.idProducto} to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}>
                                        <div className='cardProdcutSelected'>
                                            <img src={obtenerImagen(item)} alt="imagen" />
                                            <div className='cardTextSelected'>
                                                <h4>{item.titulo}</h4>
                                                <span>{item.descripcion}</span>
                                                <div className='deFLexPrice'>
                                                    <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                    {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                                                        <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                    )}
                                                </div>
                                                <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard' />
                                            </div>
                                        </div>
                                    </Anchor>
                                ))}
                        </div>
                    </div>
                )
            )}
        </div>
    );
}
